import { piecesValidation } from "../helpers/multipleAddonsHelper";
import { MultiOrderItem } from "../types/items";

type Validation = {
  hasError?: boolean;
  hasWarning?: boolean;
  message: string;
};
export type SelectedItem = {
  validation: Validation;
  availableStock?: number;
  name?: string;
} & Partial<MultiOrderItem>;

export type SelectedItems = { [key: number]: SelectedItem };

type SelectItemAction = {
  type: "SELECT_ITEM";
  payload: {
    index: number;
    availableStock?: number;
    item: { name: string } & MultiOrderItem;
  };
};

type ChangePiecesAction = {
  type: "CHANGE_PIECES";
  payload: {
    index: number;
    pieces: string;
  };
};

type ClearInputAction = {
  type: "CLEAR_INPUT";
  payload: {
    index: number;
    pieces: string;
  };
};

type ResetItemsAction = {
  type: "RESET_ITEMS";
};

export type SelectedItemsAction =
  | SelectItemAction
  | ChangePiecesAction
  | ClearInputAction
  | ResetItemsAction;

const selectedItemsReducer = (
  state: SelectedItems,
  action: SelectedItemsAction
): SelectedItems => {
  switch (action.type) {
    case "SELECT_ITEM": {
      const { index, item, availableStock } = action.payload;
      if (index in state) {
        const newState = { ...state };
        delete newState[index];
        return newState;
      } else {
        return {
          ...state,
          [index]: {
            ...item,
            selectedPieces: item.lastRefilledQuantity.toString(),
            validation: piecesValidation(
              item.lastRefilledQuantity.toString(),
              item.maxAmount,
              availableStock
            ),
          },
        };
      }
    }
    case "CHANGE_PIECES": {
      const { index, pieces } = action.payload;
      if (!(index in state)) return state;
      return {
        ...state,
        [index]: {
          ...state[index],
          selectedPieces: pieces,
          validation: piecesValidation(
            pieces,
            // @ts-expect-error - getting fixed in COAPP-12328 (Daniel)
            state[index].maxAmount,
            // @ts-expect-error - getting fixed in COAPP-12328 (Daniel)
            state[index].availableStock
          ),
        },
      };
    }
    case "CLEAR_INPUT": {
      const { index } = action.payload;
      if (!(index in state)) return state;
      return {
        ...state,
        [index]: {
          ...state[index],
          selectedPieces: "",
          // @ts-expect-error - getting fixed in COAPP-12328 (Daniel)
          validation: piecesValidation("", state[index].maxAmount),
        },
      };
    }
    case "RESET_ITEMS": {
      return {};
    }
    default:
      return state;
  }
};

export default selectedItemsReducer;
